import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-utilities',
    templateUrl: './utilities.component.html',
    styleUrls: ['./utilities.component.css'],
    standalone: false
})
export class UtilitiesComponent implements OnInit {
  private authService = inject(AuthService);


  ngOnInit(): void {
    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    body.classList.add('utilities');
  }

  getUserRole(){
    return this.authService.user.role;
  }
}
